import React from 'react'

const Hero = () => {
    return (
        <section className="max-container hero_comp">
            <h1 className="hero_title">
                Pilvon
            </h1>
        </section>
    )
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero.jsx